import * as XLSX from 'xlsx';
import { IngredientPurchaseRecord } from '../types';

const formatDateTime = (timestamp: string): string => {
  if (!timestamp) return 'N/A';
  const date = new Date(timestamp);
  if (isNaN(date.getTime())) return 'N/A';
  
  const day = String(date.getDate()).padStart(2, '0');
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const year = date.getFullYear();
  const hours = String(date.getHours()).padStart(2, '0');
  const minutes = String(date.getMinutes()).padStart(2, '0');
  
  return `${day}/${month}/${year} ${hours}:${minutes}`;
};

const TAX_TYPE_LABELS: Record<string, string> = {
  'no_recuperable': 'No recuperable',
  'no_deducible_iva': 'Boleta (sin IVA)',
  'deducible_iva': 'Factura (con IVA)',
};

const transformComprasData = (compras: IngredientPurchaseRecord[]) => {
  return compras.map(compra => ({
    'ID Compra': compra.ingredient_purchase_id,
    'Producto': compra.ingredient_name || 'N/A',
    'Proveedor': compra.provider_name || 'Sin Proveedor',
    'Marca': compra.brand_name || 'N/A',
    'Categoría': compra.expense_category_name || 'Sin categoría',
    'Fecha Compra': compra.purchase_date || formatDateTime(compra.timestamp),
    'Fecha Registro': formatDateTime(compra.timestamp),
    'Cantidad': compra.quantity,
    'Unidad': compra.unidad_medida_name || 'N/A',
    'Total Neto': Math.round(compra.total_neto),
    'Tipo IVA': compra.tax_type ? TAX_TYPE_LABELS[compra.tax_type] || compra.tax_type : 'Sin clasificar',
    'Monto IVA': compra.tax_amount != null ? Math.round(compra.tax_amount) : 0,
    'Total con IVA': compra.total_with_tax != null ? Math.round(compra.total_with_tax) : Math.round(compra.total_neto),
    'Precio Unitario': Math.round(compra.unit_price),
    'Notas': compra.notes || '',
    'ID Factura': compra.invoice_id || 'N/A',
  }));
};

export const exportComprasToExcel = (
  compras: IngredientPurchaseRecord[],
  startDate: string,
  endDate: string
) => {
  try {
    // Transform data
    const data = transformComprasData(compras);

    // Create workbook and worksheet
    const wb = XLSX.utils.book_new();
    const ws = XLSX.utils.json_to_sheet(data);

    // Set column widths
    ws['!cols'] = [
      { wch: 12 }, // ID Compra
      { wch: 30 }, // Producto
      { wch: 25 }, // Proveedor
      { wch: 20 }, // Marca
      { wch: 20 }, // Categoría
      { wch: 14 }, // Fecha Compra
      { wch: 18 }, // Fecha Registro
      { wch: 12 }, // Cantidad
      { wch: 15 }, // Unidad
      { wch: 15 }, // Total Neto
      { wch: 20 }, // Tipo IVA
      { wch: 12 }, // Monto IVA
      { wch: 15 }, // Total con IVA
      { wch: 18 }, // Precio Unitario
      { wch: 30 }, // Notas
      { wch: 15 }  // ID Factura
    ];

    // Add worksheet to workbook
    XLSX.utils.book_append_sheet(wb, ws, 'Compras');

    // Generate filename with date range
    const startDateFormatted = startDate.split('T')[0];
    const endDateFormatted = endDate.split('T')[0];
    const filename = `Compras_${startDateFormatted}_a_${endDateFormatted}.xlsx`;

    // Write file
    XLSX.writeFile(wb, filename);

    return true;
  } catch (error) {
    console.error('Error exporting to Excel:', error);
    return false;
  }
};

export const exportFilteredCompras = (
  compras: IngredientPurchaseRecord[],
  startDate: string,
  endDate: string
) => {
  if (compras.length === 0) {
    return false;
  }
  return exportComprasToExcel(compras, startDate, endDate);
};
